import React, { useState } from "react";
//import { Button } from "react-bootstrap"
import { Button, Divider, InputNumber, Tooltip } from 'antd';
import { ApartmentOutlined, CheckOutlined, FormOutlined, DeleteRowOutlined, PlusOutlined, LinkOutlined, FastForwardOutlined, FastBackwardOutlined} from '@ant-design/icons';

import * as AzureService from "../../../api/ticketsApiAzure";
import * as tConst from "../../../common/Constants";
import * as date from "../../../utils/date";
import {findPrevQuarterStart, findNextQuarterStart} from "../data/findQuarterStart";
import moment from "moment";
import { createChildrenTicket } from "../../../utils/ticketUtils";

const ChartMenuToolbar = ({ ...props }) => {
    const [move, setMove] = useState(0);
    const [length, setLength] = useState(props.selectedTicket.Length);
    const [includeTeamDependencies, setIncludeTeamDependencies] = useState(false);
    const [linkToTicketID, setLinkToTicketID] = useState("0");
    const [showCreateLink, setShowCreateLink] = useState(false);
    const [showCreateTeamDependency, setShowCreateTeamDependency] = useState(false);

    const planningProject = ( true || props.selectedTicket.fields[tConst.AF_PROJECT] === "RnD Planning");

    const dis = (["Epic", "Feature", "Initiative"].indexOf(props.selectedTicket.fields[tConst.AF_TYPE]) > -1);
    const unchangedPeriod = (move === 0 && length === props.selectedTicket.Length);
    const _show_hide_text = (includeTeamDependencies) ? "Hide Team Dependencies" : "Show Team Dependencies";
    // if (!props.isLoaded) {
    //     return <></>
    // }
    return (
        <div style={{ backgroundColor: '#F1F2F3', padding: '10px', borderRadius: '5px' }}>
            <Tooltip title="Add Planning Tasks">
                <Button
                    color="primary" variant="solid"
                    size="sm"
                    icon={<FormOutlined />}
                    disabled={!dis}
                    onClick={() => {
                        tConst.AZURE_SPECS.map((spec) => {
                            return AddPlanningTasks(props.auth, props.selectedTicket, spec);
                        })
                        props.onClose();

                    }}
                /> &nbsp;
            </Tooltip>

            <Tooltip title="Remove from Timeline">
                <Button
                    color="primary" variant="solid"
                    size="sm"
                    icon={<DeleteRowOutlined />}
                    onClick={() => {
                        AzureService.RemoveFromTimeline(props.auth, props.selectedTicket.id)
                        props.onClose();

                    }} />
            </Tooltip>
            {planningProject &&
                <>
                    <Divider type="vertical" />
                    <Tooltip title={showCreateTeamDependency ? "Hide Create Initiative in Team projects" : "Create Initiative in Team projects"}>
                        <Button
                            color="primary"
                            icon={<PlusOutlined />}
                            variant={showCreateTeamDependency ? "outline" : "solid"}
                            size="sm"
                            onClick={() => {
                                setShowCreateLink(false);
                                setShowCreateTeamDependency(!showCreateTeamDependency);
                            }}
                        />
                    </Tooltip>
                </>}

            {planningProject && <Tooltip title={showCreateLink ? "Hide Link " : "Link Predecessor to existing ticket"}>
                <Button
                    color="primary"
                    icon={<LinkOutlined />}
                    variant={showCreateLink ? "outline" : "solid"}
                    size="sm"
                    onClick={() => {
                        setShowCreateTeamDependency(false)
                        setShowCreateLink(!showCreateLink);
                    }}
                />
            </Tooltip>}


            <Tooltip title={_show_hide_text}>
                <Button
                    color="primary"
                    icon={<ApartmentOutlined />}
                    variant={(includeTeamDependencies ? "outlined" : "solid")}
                    size="sm"
                    onClick={() => {
                        setIncludeTeamDependencies(!includeTeamDependencies);
                    }}
                />
            </Tooltip>

            <Divider type="vertical" />

            <label>Move: </label>
            <InputNumber min={-12} max={12} value={move} onChange={(value) => { setMove(value); }} /> &nbsp;&nbsp;

            <label>Length: </label>
            <InputNumber min={1} max={24} value={length} onChange={(value) => { setLength(value) }} /> &nbsp;&nbsp;


            <Tooltip title="Update period and lenght">
                <Button color="primary" icon={<CheckOutlined />} variant="solid" size="sm" onClick={() => {
                    if (move !== 0 || length !== props.selectedTicket.Length) {
                        props.onMoveAndExtendIteration(props.selectedTicket, move * 14, (length - props.selectedTicket.Length) * 14);
                    }
                    console.log("Move: ", move, "Length: ", (length - props.selectedTicket.Length) * 14);
                }} disabled={unchangedPeriod} />
            </Tooltip>

            <Divider type="vertical" />
            <Tooltip title="Move to Previous Quarter">
                <Button color="primary" icon={<FastBackwardOutlined />} variant="solid" size="sm" onClick={() =>{

                    // Find how many days we must move to next quarter
                    const startIteration = props.selectedTicket.fields[tConst.AF_START_ITERATION]
                    const newStartDate = findPrevQuarterStart(startIteration)
                    const moveNumberOfDays = moment(newStartDate).diff(moment(startIteration), "days")
                    
                    props.onMoveAndExtendIteration(props.selectedTicket, moveNumberOfDays, 0);
                    
                }}/>
            </Tooltip>

            <Tooltip title="Move to Next Quarter">
                <Button color="primary" icon={<FastForwardOutlined />} variant="solid" size="sm" onClick={() =>{

                    // Find how many days we must move to next quarter
                    const startIteration = props.selectedTicket.fields[tConst.AF_START_ITERATION]
                    const newStartDate = findNextQuarterStart(startIteration)
                    const moveNumberOfDays = moment(newStartDate).diff(moment(startIteration), "days")

                    props.onMoveAndExtendIteration(props.selectedTicket, moveNumberOfDays, 0);
                    
                }}/>
            </Tooltip>

            <br />

            {showCreateLink &&
                <>
                    <label>Link to Ticket ID: </label> &nbsp;
                    <InputNumber min={0} value={linkToTicketID} onChange={(value) => { setLinkToTicketID(value) }} />
                    <Tooltip title="Link">
                        <Button
                            // disabled={(linkToTicketID !== 0 && linkToTicketID !== selectedTicket.id)}
                            color="primary"
                            icon={<CheckOutlined />}
                            variant="solid"
                            size="sm"
                            onClick={() => {
                                props.setRefreshOnClose()
                                if (linkToTicketID !== 0 && linkToTicketID !== props.selectedTicket.id) {
                                    AzureService.createLink(props.auth, props.selectedTicket.id, linkToTicketID, "Dependency-Reverse").then((response) => {
                                        props.onRefreshChildren();
                                        console.log("Link created: ", response);
                                    });
                                }
                            }}
                        />
                    </Tooltip>
                </>}

            {showCreateTeamDependency &&
                <>
                    <hr />
                    <table style={{ width: "100%" }}>
                        <thead>
                            <tr>
                                <th style={{ width: "15%" }}>Project</th>
                                <th style={{ width: "60%" }}>Title</th>
                                <th style={{ width: "10%" }}>Ticket ID</th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.selectedTicket.Teams.map((team) => {
                                const _teamSetting = tConst.TEAMS_LIST.filter((item) => item.team === team)?.[0];

                                if (props.children?.filter((child) => child.fields[tConst.AF_PROJECT] === _teamSetting.project).length > 0) {
                                    return props.children?.filter((child) => child.fields[tConst.AF_PROJECT] === _teamSetting.project).map((child) => {
                                        return (<>
                                            <tr>
                                                <td>{child.fields[tConst.AF_PROJECT]}</td>
                                                <td>{child.fields[tConst.AF_TITLE]}</td>
                                                <td>{child.id}</td>
                                            </tr>
                                        </>)
                                    })
                                }
                                else {

                                    const _teamSetting = tConst.TEAMS_LIST.filter((item) => item.team === team);
                                    const _allowAddTicketsInTeamProject = (
                                        // If selected ticket is in done state
                                        tConst.ADO_INACTIVE_STATUSES.indexOf(props.selectedTicket.fields[tConst.AF_STATE]) > -1 ||
                                        // is Team does not have a project 
                                        (_teamSetting.length > 0 && _teamSetting[0].project === "") ||
                                        // if Team does not have a ticket type
                                        (_teamSetting.length > 0 && _teamSetting[0].ticketType === "")
                                    )
                                    return (<>
                                        <tr>
                                            <td>{team}</td>
                                            <td>{ }</td>
                                            <td>
                                                <Button
                                                    disabled={_allowAddTicketsInTeamProject}
                                                    color="primary"
                                                    icon={<PlusOutlined />}
                                                    variant="solid"
                                                    size="sm"
                                                    onClick={() => {
                                                        const prefix = "**** ";
                                                        props.setRefreshOnClose()
                                                        createChildrenTicket(props.auth, props.selectedTicket, team, props.onRefreshChildren, prefix);
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                    </>)
                                }
                            })}
                        </tbody>

                    </table>
                </>}



        </div>
    )

}


const AddPlanningTasks = (auth, selectedTicket, spec) => {
    const initiative = selectedTicket.fields[tConst.AF_INITIATIV];
    const _project = selectedTicket.fields[tConst.AF_PROJECT];
    const _id = selectedTicket.id;
    const _title = spec + ": " + selectedTicket.fields[tConst.AF_TITLE];
    const PlanningPriority = selectedTicket.planningPri;
    const _PlanningPriority = 0.1 + Number(PlanningPriority)
    const _end = new Date(selectedTicket?.fields[tConst.AF_END_ITERATION]);
    const _start = new Date(selectedTicket?.fields[tConst.AF_START_ITERATION]);
    const _dateDiff = date.date_diff_indays(_start, _end);

    const _FuncSpec = tConst.AZURE_SPECS[0];


    if (spec === _FuncSpec) {
        _end.setDate(_end.getDate() - (14 + _dateDiff));
        _start.setDate(_start.getDate() - 28)

    } else {
        _end.setDate(_end.getDate() - (_dateDiff));
        _start.setDate(_start.getDate() - 14)
    }

    const data = JSON.stringify([
        {
            "op": "add",
            "path": "/fields/System.Title",
            "from": null,
            "value": _title
        },
        {
            "op": "add",
            "path": "/relations/-",
            "value": {
                "rel": tConst.AF_REL_PARENT,

                "url": tConst.AZURE_DEVOPS_BASE_URI + _project + "/_apis/wit/workItems/" + _id
            }
        },
        {
            "op": "add",
            "path": "/fields/" + tConst.AF_INITIATIV,
            "value": initiative
        },
        {
            "op": "add",
            "path": "/fields/" + tConst.AF_PLANNING_PRIORITY,
            "value": _PlanningPriority
        },
        {
            "op": "add",
            "path": "/fields/" + tConst.AF_START_ITERATION,
            "value": _start
        },
        {
            "op": "add",
            "path": "/fields/" + tConst.AF_END_ITERATION,
            "value": _end
        },
        {
            "op": "add",
            "path": "/fields/" + tConst.AF_PLANNING_STATUS,
            "value": "9. N/A"
        }
    ])
    AzureService.createTicketInternal(auth, _project, "product backlog item", data)
}


export default ChartMenuToolbar